<template>
  <div id="page" class="fixed">
    <div class="app-content course-container" ref="container" :class="{show: show}">
      <div style="position: relative;">
        <div class="fd-video" v-for="(item, k) in articleTempId" :style="k+1 === articleTempId.length ? {paddingBottom: '14.00966vw'} : {}">
          <div class="fd-video-inner">
            <a class="fd-video-play" :href="item.video">
              <img class="fd-video-img" :src="item.image" alt="">
              <span class="fd-play-btn">
                <i class="iconfont fdapp-play"></i>
              </span>
            </a>
            <div class="fd-video-info">
              <span class="fd-video-title">{{item.title}}</span>
              <span class="fd-video-share" onclick="onShareArticle()">
                <i class="iconfont fdapp-fenxiang"></i> 分享视频
              </span>
            </div>
          </div>
        </div>
        <div class="fd-video" v-if="!articleTempId.length" style="padding: 24px 16px">
        </div>
        <!-- 导航栏切换 -->
        <div class="course-nav">
          <div class="a" :class="{'nav-active': categoryType === 1}" @click="categoryType = 1">
            <div class="nav-inner novice-tutorial">
              <span class="nav-icon"><i class="iconfont fdapp-jiantou"></i></span>
              <span class="nav-title">新手教程</span>
            </div>
          </div>
          <div class="a" :class="{'nav-active': categoryType === 2}" @click="categoryType = 2">
            <div class="nav-inner common-problem">
              <span class="nav-icon"><i class="iconfont fdapp-wenhao"></i></span>
              <span class="nav-title">常见问题</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 分享赚钱教程 -->
      <div class="fd-tutorial" v-if="categoryType === 1">
        <div class="tutorial-inner" v-for="item in articleTempId1" :key="item.id" v-if="!item.isJump">
          <router-link :to="{path: '/article', query: {id: item.id}}" class="tutorial-image">
            <img v-if="item.image" :src="item.image" alt="" class="tutorial-img">
            <template v-else>
              <img src="@/assets/images/bg1.png" alt="" class="tutorial-img">
              <span class="tutorial-subtitle">{{item.subTitle}}</span>
            </template>
          </router-link>
          <div class="tutorial-info">
            <router-link :to="{path: '/article', query: {id: item.id}}" style="height: 100%">
              <span class="tutorial-title">{{item.title}}</span>
            </router-link>
            <div style="display: inherit; justify-content: space-between;">
              <router-link :to="{path: '/article', query: {id: item.id}}" style="width: calc(100% - 70px); display: block"></router-link>
              <span class="tutorial-share" @click="() => onShareArticle(item)">
                <i class="iconfont fdapp-fenxiang"></i> 分享
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 常见问题 -->
      <div class="fd-problem" v-if="categoryType === 2">
        <div class="fd-row" v-for="category in (categoryTempId2.children || [])" :key="category.id">
          <div class="fd-label">
            <img :src="category.icon" alt="">
            <span style="font-size: 12px">{{category.name}}</span>
          </div>
          <div class="fd-lists">
            <router-link v-for="item in articleTempId2" :key="item.id" v-if="item.categoryId === category.id && !item.isJump" :to="{path: '/article', query: {id: item.id}}" class="fd-list">{{item.title}}</router-link>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="showLoading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
            <p class="weui-toast__content">加载中...</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="less" scoped>
#page {
  height: 100vh;
}
#page.fixed {
  height: 100vh;
  overflow: hidden;
}
.app-content {
  opacity: 0;
  transition: opacity 0.2s ease;
  height: 100%;
  overflow-y: auto;
}
.app-content.show {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.2s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

#toast {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 10px;
  border-radius: 3px;
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.hide {
  display: none;
}

.fadeOut {
  animation: fadeOut .5s;
}

.fadeIn {
  animation: fadeIn .5s;
}

.confirm-dialog .weui-dialog__hd {
  position: relative;
  padding: 16px 24px 8px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px #efefef solid;
}

.confirm-dialog .weui-dialog__hd .close {
  position: absolute;
  top: 14px;
  right: 14px;
}

.confirm-dialog .weui-dialog__title {
  font-size: 16px;
  font-weight: 600;
}
.confirm-dialog .weui-dialog__subtitle {
  font-size: 13px;
  color: #999;
  padding-top: 4px;
}

.confirm-dialog .weui-dialog__bd {
  padding-top: 4px;
  padding-bottom: 0;
  margin-bottom: 20px;
  text-align: left;
}

.confirm-dialog .weui-dialog__bd .desc {
  font-size: 13px;
  color: red;
  padding-top: 10px;
  padding-bottom: 5px;
}

.confirm-dialog .weui-dialog__bd .input input {
  height: 40px;
  line-height: 40px;
  border: 0;
  border-radius: 6px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #efefef;
  font-size: 16px;
  width: 100%;
  outline:none;
}

.confirm-dialog .weui-dialog__ft:after {
  display: none;
}

.confirm-dialog .weui-dialog__ft {
  padding-bottom: 14px;
  .weui-btn_primary {
    width: 60%;
    padding: 0;
    margin: 0 auto;
    background-color: #d8c078;
    color: #fff;
    font-weight: 500;
    border-radius: 20px;
    height: 44px;
    line-height: 46px;
  }
}

.fd-video{background:#f3f4f6;padding:16px 16px 0}
.fd-video-inner{position:relative;background:#fff;border-radius:10px}
.fd-video-play{position:relative;background:#fff;border-radius:10px 10px 0 0; display: block}
.fd-video-img{width:100%;display:block;border-radius:10px;cursor:pointer}
.fd-play-btn{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:48px;height:48px;color:#fff;background:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;border-radius:1000px;pointer-events:none}
.fd-play-btn i{font-size:22px}
.fd-video-info{width:100%;background:#fff;display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-radius:0 0 10px 10px;box-sizing:border-box}
.fd-video-title{font-size:14px;color:#333}
.fd-video-share{line-height:1;font-size:14px;color:#fe2d64;display:inline-flex;align-items:center;padding:6px 12px;border:1px solid #fe2d64;border-radius:1000px;cursor:pointer}
.fd-tutorial{background:#fff;padding:14.00966vw 16px 16px}
.fd-tutorial a{text-decoration:none}
.tutorial-inner{position:relative;display:flex;padding:12px;margin-bottom:16px;border:1px solid #e9eaec;border-radius:10px}
.tutorial-inner:last-child{margin-bottom:0}
.tutorial-inner>a{width:40%;display:block}
.tutorial-img{width:100%;height:100%;display:block}
.tutorial-info{width:60%;display:flex;flex-direction:column;justify-content:space-between;padding-left:12px;box-sizing:border-box}
.tutorial-title{font-size:14px;color:#333;display:block;text-decoration:none;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.tutorial-image{position: relative;}
.tutorial-subtitle{position: absolute; font-size: 18px; color: #fff; font-weight: 500; top: 50%; left: 0; text-align: center; transform: translateY(-50%); padding: 0 12px;}
.tutorial-share{line-height:1;font-size:14px;color:#fe2d64;display:inline-flex;align-items:center;padding:8px 12px;border:1px solid #fe2d64;border-radius:1000px;cursor:pointer; white-space: nowrap;}
.course-nav{position:absolute;top:100%;transform:translateY(-50%);width:100%;display:flex;justify-content:space-between;padding:0 16px;box-sizing:border-box;z-index:200}
.course-nav .a{width:calc(~"50% - 8px");font-size:16px;color:#333;background:#fff;text-decoration:none;display:block;padding:3.86473vw 0 3.86473vw 3.86473vw;box-shadow:0 8px 8px 0 rgba(202,202,202,.21);border-radius:10px}
.course-nav>.a:first-child{margin-right:8px}
.course-nav>.a:last-child{margin-left:8px}
.nav-icon{width:8.69565vw;height:8.69565vw;display:inline-flex;align-items:center;justify-content:center;margin-right:6px;border-radius:1000px}
.nav-inner span:last-child{font-size:3.86473vw}
.novice-tutorial .nav-icon{color:#fff;background:linear-gradient(-90deg,rgba(254,48,101,1) 0,rgba(255,98,123,1) 100%)}
.a.nav-active:first-child{color:#fff;background:linear-gradient(-90deg,rgba(254,48,101,1) 0,rgba(255,98,123,1) 100%);box-shadow:0 8px 8px 0 rgba(254,50,102,.15)}
.nav-active .novice-tutorial .nav-icon{color:#ff5b77;background:#fff}
.fdapp-jiantou{font-size:4.34782vw}
.common-problem .nav-icon{color:#fff;background:linear-gradient(-90deg,rgba(255,124,60 ,1) 0,rgba(255,161,114,1) 100%)}
.a.nav-active:last-child{color:#fff;background:linear-gradient(-90deg,rgba(255,124,60 ,1) 0,rgba(255,161,114,1) 100%);box-shadow:0 8px 8px 0 rgba(255,124,61,.21)}
.nav-active .common-problem .nav-icon{color:#ff742f;background:#fff}
.fdapp-wenhao{font-size:5.314vw}
.fd-course{padding:14.00966vw 16px 16px;background:#fff}
.fd-problem{padding:14.00966vw 16px 16px;background:#fff;}
.fd-row{display:flex;align-items:center;justify-content:space-between;padding:16px 0;border-bottom:1px solid #e9eaec}
.fd-row:last-child{border-bottom:none}
.fd-label{position:relative;min-width:88px;font-size:14px;display:inline-flex;align-items:center;flex-direction:column;padding:0 16px;box-sizing:border-box}
.fd-label>img{width:39px;height:39px;display:block;margin-bottom:6px}
.fd-lists{position:relative;width:calc(~"100% - 88px");padding-left:16px;box-sizing:border-box}
.fd-lists::after{content:"";position:absolute;top:0;left:-.5px;width:1px;height:100%;background:#e9eaec;display:block}
.fd-lists a{font-size:14px;color:#333;text-decoration:none;display:block;word-break:normal;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding:12px 0;border-bottom:1px solid #e9eaec}
.fd-lists a:first-child{padding-top:0}
.fd-lists a:last-child{padding-bottom:0;border-bottom:none}
.video-modal{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.4);display:none;z-index:1999}
.video-dialog{position:relative;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}
.video-dialog video{width:94%;display:block;margin:0 auto}
.video-modal-close{width:38px;height:38px;background:#fff;display:inline-flex;align-items:center;justify-content:center;margin-top:32px;border:1px solid #fe2d64;border-radius:1000px;cursor:pointer}
.video-modal-close i{font-size:24px;color:#fe2d64}

</style>

<script>
import request from "@/pages/course/utils/request";
import gfRequest from "@/pages/course/utils/gfRequest";
import {handleTree, handleNodeIds} from "@/pages/course/utils/tree";
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: true,
      confirmDialog: false,
      showToast: false,
      memberId: null,
      categoryType: 1,
      category: [],
      categoryTempId1: null,
      categoryTempId2: null,
      articleTempId: [],
      articleTempId1: [],
      articleTempId2: [],
      appEnv: {
        prod: true,
        appKey: '',
      },
      scrollY:0,
    };
  },
  created() {
    this.appEnv.prod = process.env.VUE_APP_RELEASE === 'prod';
    if (!this.appEnv.prod) {
      this.appEnv.appKey = 'EDF0763043A073BC';
      // new VConsole();
    }
  },
  activated() {
    if(this.scrollY > 0){
      this.$refs.container.scrollTop = this.scrollY
    }
  },
  beforeRouteLeave (to, from, next) {
    this.scrollY = this.$refs.container.scrollTop
    next()
  },
  mounted() {
    const appKey = this.$route.query.appkey ||'';
    if (appKey) this.appEnv.appKey = appKey;
    if (!this.appEnv.appKey) {
      this.showLoading = false;
      this.show = true;
      this.toast('存在未配置的参数请联系客服');
      return;
    }

    this.showLoading = true;
    new Promise(async () => {
      await this.getCategory().catch(err => {})
      Promise.all([this.getArticle(0), this.getArticle(1), this.getArticle(2)]).then(() => {
        this.show = true;
        setTimeout(() => {
          this.showLoading = false;
        }, 150);
      })
    });
  },
  watch: {
  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.checkUserInfo;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: v},
        }).then().catch(err => {})
      }
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version }
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, wxpay, alipay, page_reminder, background, color} = resp;
        this.appEnv.appKey = version;
        this.background = background;
        this.color = color ? this.colorRgb(color).join(',') : null;
        this.isWxPay = wxpay;
        this.isAliPay = alipay;
        this.checkAppKey = appkey === version;
        this.pageReminder = page_reminder.split(/[\n\r]/g);
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getCategory() {
      const newRequest = gfRequest({
        url: `/api/course/category`,
        method: 'GET',
        params: {
          appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId
        }
      });
      newRequest.then((resp) => {
        this.category = handleTree(resp.data.list || [])
        const templateId1 = this.category.find(t => t.templateId === 1)
        const templateId2 = this.category.find(t => t.templateId === 2)
        this.categoryTempId1 = templateId1
        this.categoryTempId2 = templateId2
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.message);
        }
      })
      return newRequest;
    },
    getArticle(tempId) {
      let ids = []
      if (tempId === 0) {
      } else if (tempId === 1) {
        ids = handleNodeIds(this.categoryTempId1)
      } else if (tempId === 2) {
        ids = handleNodeIds(this.categoryTempId2)
      } else {
        this.toast('未知的分类类型');
      }
      const newRequest = gfRequest({
        url: `/api/course/article`,
        method: 'GET',
        params: {
          appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, categoryIds: tempId ? ids.join(',') : '0', pageSize: 999, sort: 'asc'
        }
      });
      newRequest.then((resp) => {
        const list = resp.data.list || [];
        if (tempId === 0) {
          this.articleTempId = list
        } else if (tempId === 1) {
          this.articleTempId1 = list
        } else if (tempId === 2) {
          this.articleTempId2 = list
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.message);
        }
      })
      return newRequest;
    },
    appMemberLink() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          invite_code: this.userInfo.invite_code
        }
      });
      newRequest.then((resp) => {
        this.memberId = resp.id;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    onShareArticle(event) {
      if (event.isJump && event.video) {
        shareAction({
          isShow: 1,
          desc: event.subTitle,
          thumb: event.image,
          title: event.title,
          contentUrl: event.video
        })
      } else {
        shareAction({
          isShow: 1,
          desc: event.subTitle,
          thumb: event.image,
          title: event.title,
          contentUrl: location.origin + location.pathname + '#/article?id=' + event.id
        })
      }
    }
  }
}
</script>
